import { makeRequest } from 'utils/requestLogger';

const showPremade = (id) =>
  makeRequest('get', `/api/universe/roundtables/${id}/admin`);
const getAll = () => makeRequest('get', `/api/universe`);

// Admin only
const createNewPremade = (type) => makeRequest('post', `/api/premades`, { type });
const getAllPremades = () => makeRequest('get', `/api/premades`);
const getPremadeById = (id) => makeRequest('get', `/api/premades/${id}`);
const deletePremade = (id) => makeRequest('delete', `/api/premades/${id}`);
const editPremade = (id, payload) =>
  makeRequest('put', `/api/premades/${id}`, payload);
const getAllAsAdmin = () => makeRequest('get', `/api/universe/admin`);
const duplicatePremade = (id) =>
  makeRequest('post', `/api/premades/${id}/duplicate`);
const getPremadesByPage = (filters) =>
  makeRequest('post', `/api/premades/byPage`, filters);

export default {
  createNewPremade,
  deletePremade,
  editPremade,
  showPremade,
  getAll,
  getAllAsAdmin,
  getAllPremades,
  getPremadeById,
  getPremadesByPage,
  duplicatePremade,
};



// WEBPACK FOOTER //
// ./src/app/services/premades/premadeServices.js